import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Honeymoon: React.FC = () => {
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const accountNumber = 'DE85 1001 0178 8516 2677 80';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(accountNumber.replace(/\s/g, ''));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="honeymoon" className="relative py-10 bg-gradient-to-br from-cream-100 to-cream-200 overflow-hidden">
      <div className="container-max section-padding">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="font-wasted text-4xl font-normal text-wedding-primary mb-2">
            Luna de miel
          </h2>
          <p className="font-avenir text-xl text-terracotta-700 font-semibold mb-3">
            Próximo destino...
          </p>
          <p className="font-avenir text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
           Vietnam nos espera! ✈️ 🌏
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >

          {/* Gift section */}
          <div className="bg-gradient-to-br from-olive-50 to-sand-50 rounded-3xl p-8 md:p-12 shadow-lg border border-olive-200">
            <div className="text-center">
              <div className="mb-6">
                <span className="text-5xl">🍯🌝</span>
              </div>
              <p className="font-avenir text-base md:text-lg text-gray-700 mb-6 leading-relaxed max-w-2xl mx-auto">
                Compartir este día especial con vosotros es lo que más ilusión nos hace, 
                pero si queréis contribuir a nuestro viaje de novios, 
                os estaremos infinitamente agradecidos. 
              </p>
              
              <button
                onClick={() => setShowGiftModal(true)}
                className="font-avenir bg-gradient-to-r from-olive-600 to-forest-700 text-white px-8 py-4 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                Regalo
              </button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Gift Modal */}
      <AnimatePresence>
        {showGiftModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setShowGiftModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: 'spring', duration: 0.5 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white rounded-3xl p-8 md:p-12 max-w-lg w-full shadow-2xl"
            >
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">🤍</div>
                <h3 className="font-wasted text-3xl font-normal text-wedding-primary mb-2">
                ¡Muchísimas gracias!
                </h3>
              </div>

              {/* Account number */}
              <div className="mb-6">
                <p className="font-avenir text-sm text-gray-600 mb-3 text-center">
                  Número de cuenta:
                </p>
                <button
                  onClick={copyToClipboard}
                  className="w-full bg-sand-100 hover:bg-sand-200 p-4 rounded-xl border-2 border-sand-300 transition-all group"
                >
                  <p className="font-avenir text-lg md:text-xl font-bold text-forest-700 mb-2 tracking-wider">
                    {accountNumber}
                  </p>
                  <p className="font-avenir text-xs text-gray-500 group-hover:text-gray-700">
                    {copied ? '✅ ¡Copiado!' : '📋 Click para copiar'}
                  </p>
                </button>
              </div>

              {/* Close button */}
              <button
                onClick={() => setShowGiftModal(false)}
                className="font-avenir w-full btn-secondary"
              >
                Cerrar
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Honeymoon;
